import React, {useContext, useState} from "react";
import {Button, FormGroup, Modal} from "reactstrap";
import {InputArraySelect} from "@pages/components/InputSelect";
import InputCustom from "@pages/components/InputCustom";
import InputToggle from "@pages/components/InputToggle";
import {DealContext} from "@pages/deals/context";

export default function SignDocument() {
    const dealContext = useContext(DealContext);
    const {
        documentsOld,
        documentModal, setDocumentModal,
        sendDocument,
        seeDocumentPreview
    } = dealContext;
    const [document,setDocument]=useState(null);
    return (   <Modal
        isOpen={documentModal}
        toggle={() => setDocumentModal(false)}
        className="modal-dialog-centered"
    >
        <div className="modal-header">
            <h6 className="modal-title">{`Sign document`}</h6>
            <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => setDocumentModal(false)}
            >
                <span aria-hidden={true}>×</span>
            </button>
        </div>
        <div className="modal-body">
            <FormGroup>
                <InputArraySelect
                    newLabel={`Document type`}
                    options={Object.values(documentsOld)}
                    value={document && document.adobe_document_type ? document.adobe_document_type : ''}
                    valueKey={`id`}
                    labelKey={`document_name`}
                    onChange={(e) => setDocument({
                        ...document,
                        adobe_document_type: e.target.value,
                    })}
                />
            </FormGroup>
            <InputCustom
                label={`Document name`}
                value={document && document.adobe_document_name ? document.adobe_document_name : ''}
                onChange={(e) => setDocument({
                    ...document,
                    adobe_document_name: e.target.value,
                })}
            />
            <InputCustom
                type={`textarea`}
                label={`Email template`}
                rows={5}
                value={document && document.adobe_email_template ? document.adobe_email_template : ''}
                onChange={(e) => setDocument({
                    ...document,
                    adobe_email_template: e.target.value,
                })}
            />
            <div className='col-12 col-md-12 col-sm-12'>
                <InputToggle
                    label={`Is local signing ?`}
                    checked={document && document.is_local_signing === 1}
                    onChange={() => {
                        setDocument({
                            ...document,
                            is_local_signing: document.is_local_signing === 1 ? 0 : 1
                        })
                    }}
                />
            </div>
        </div>
        <div className="modal-footer">
            <Button
                className="w-100 text-center"
                color="warning"
                type="button"
                onClick={() => seeDocumentPreview(document)}
            >
                {`Preview`}
            </Button>
            <Button
                className="w-100 text-center"
                color="success"
                type="button"
                onClick={() => sendDocument(document)}
            >
                {`Send`}
            </Button>
        </div>
    </Modal>)
}